module.exports = __webpack_public_path__ + "img/67.3f3ac38d.jpg";